<template>
  <CheckInChargeComponent
    v-bind="$attrs"
    :time="time"
    :chartLineData="chartLineData"
    :chartLineOptions="chartLineOptions"
    :chartMapData="chartMapData"
    :charLineSetting="charLineSetting"
    :rechargeBtn="rechargeBtn"
    :rechargePagination="rechargePagination"
    :getVipAreaData="_getVipAreaData"
  >
    <template #chart-line__head>
      <el-button
        size="120 "
        round
        class="fff-color"
        :class="activeIndex === index && 'active'"
        v-for="(item, index) in chartLine"
        :key="index"
        @click="changeRechargeChartData({ search_mode: item.mode }, index)"
      >
        {{ item.title }}
      </el-button>
    </template>
    <template #check-in__show>
      <div class="all-num">
        <span>
          <span class="num">
            {{ rechargeAmount }}
          </span>
          充值总金额
        </span>
      </div>
      <div class="icon">
        <i v-for="item in [1, 2, 3, 4, 5, 6]" class="iconfont icon-jine"></i>
      </div>
    </template>
    <template #tips>
      <span class="tips">
        会员所在区域充值数据
        <br />
        （单位：元）
      </span>
    </template>
    <template #filterInput>
      <SearchComponent
        :condition="condition"
        @updateData="_updateData"
        ref="search"
      >
        <template #default="{searchData,condition,pickerOptions}">
          <div class="input-box">
            <span class="name">会员名称：</span>
            <div class="input">
              <el-input
                v-model="condition.name"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员手机号：</span>
            <div class="input">
              <el-input
                v-model="condition.phone"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box datepick">
            <span class="name">充值时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.rechargeTime"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">充值类型：</span>
            <div class="input">
              <el-select
                v-model="condition.rechargeType"
                placeholder="请选择"
                clearable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                  v-for="item in filterDownData('rechargeType')"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">充值操作人：</span>
            <div class="input">
              <el-input
                v-model="condition.rechargeOpearator"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员性别：</span>
            <div class="input">
              <el-select
                v-model="condition.gender"
                placeholder="请选择"
                clearable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                  v-for="item in filterDownData('genderList')"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员等级：</span>
            <div class="input">
              <el-select
                v-model="condition.level"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in filterDownData('levelList')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <el-button
            @click="searchData"
            size="60"
            class="iconfont icon-sousuo"
            round
          />
        </template>
      </SearchComponent>
    </template>
    <template #table>
      <TableComponent
        @updateData="_updateData"
        :tableData="tableData"
        :pagination="pagination"
      >
        <template #default>
          <el-table-column fixed type="selection" align="center" width="135" />
          <el-table-column
            prop="recordId"
            label="序号"
            align="center"
            min-width="60"
          />
          <el-table-column align="center" label="头像" min-width="180">
            <template slot-scope="scope">
              <div class="avatar">
                <img :src="scope.row.avatar" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="名称"
            min-width="180"
          />
          <el-table-column
            prop="name1"
            label="姓名"
            align="center"
            min-width="180"
          />
          <el-table-column label="性别" align="center" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.gender | formatSex }}
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="registerTime"
            label="注册时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="level"
            label="等级"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="rechargeTime"
            label="充值时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="rechargeMoney"
            label="充值金额"
            align="center"
            min-width="180"
          />
          <el-table-column label="充值类型" align="center" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.rechargeType | formatRecharge }}
            </template>
          </el-table-column>

          <el-table-column
            prop="rechargeOpearator"
            label="充值操作人"
            align="center"
            min-width="180"
          />
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-button
                size="96"
                class="sub-color"
                v-permission:recharge="$route.meta.permission"
                @click="openRechargePop(scope.row)"
              >
                充值
              </el-button>
            </template>
          </el-table-column>
        </template>
      </TableComponent>
    </template>
    <template #pop>
      <div class="mask" v-show="dialogRechargeVisible">
        <el-dialog
          :visible.sync="dialogRechargeVisible"
          :modal-append-to-body="false"
          :close-on-press-escape="false"
          :modal="false"
          custom-class="dialog"
          :center="true"
          width="43.8rem"
        >
          <div class="box">
            <div class="avatar">
              <img :src="form.avatar" alt="" class="img" />
              <span class="name">{{ form.name }}</span>
            </div>
            <el-form :model="form" label-width="auto">
              <el-form-item label="充值金额：">
                <div class="input-box">
                  <div class="input">
                    <el-input v-model="form.money" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="充值类型：">
                <div class="input-box">
                  <div class="input">
                    <el-select v-model="form.type" placeholder="请选择">
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                        v-for="item in filterDownData('rechargeType')"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="充值操作人：">
                <div class="input-box">
                  <div class="input">
                    <el-input v-model="form.human" placeholder="请输入" />
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="98" @click="dialogRechargeVisible = false">
              取消
            </el-button>
            <el-button size="98" class="sub-color" @click="vipRechargeAmount">
              充值
            </el-button>
          </span>
        </el-dialog>
      </div>
    </template>
  </CheckInChargeComponent>
</template>
<script>
import CheckInChargeComponent from '../Components/CheckInChargeComponent/'
import SearchComponent from '../Components/SearchComponent/'
import TableComponent from '../Components/TableComponent/'
import updateData from 'mixins/updateData'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'vipRecharge',
  mixins: [updateData, filterDownData],
  components: {
    CheckInChargeComponent,
    SearchComponent,
    TableComponent
  },
  data() {
    this.keyMap = {
      recharge_list: {
        name: 'tableData',
        level_name: 'level',
        member_avatar: 'avatar',
        record_id: 'recordId',
        member_id: 'id',
        member_mobile: 'phone',
        member_name: 'name',
        member_sex: 'gender',
        memebr_turename: 'name1',
        operator: 'rechargeOpearator',
        prepaid_money: 'rechargeMoney',
        recharge_type: 'rechargeType',
        recharge_time: 'rechargeTime'
      },
      recharge_data: {
        name: 'rechargeData',
        date_time: '时间',
        recharge_amount: '充值金额',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['时间', '充值金额']
          }
        ]
      },
      area_data: {
        name: 'areaData',
        recharge_number: '充值金额',
        area_name: 'area',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['area', '充值金额']
          }
        ]
      }
    }
    this.charLineSetting = {
      yAxisName: ['单位 / 元']
    }
    this.chartLineOptions = {
      yAxis: {
        axisLabel: {
          formatter: value => {
            return `￥${value}   `
          }
        }
      }
    }
    this.chartLine = [
      { title: '实时充值数据', mode: 'real_time' },
      { title: '7天充值数据', mode: 'seven_day' },
      { title: '30天充值数据', mode: 'thirty_day' }
    ]
    this.rechargeBtn = [
      {
        title: '全部省份',
        mode: 'recharge',
        type: 'province'
      },
      {
        title: '全部城市',
        mode: 'recharge',
        type: 'city'
      }
    ]
    this.personalInfo = ''
    return {
      activeIndex: 1,
      rechargeAmount: '',
      dialogRechargeVisible: false,
      form: {
        avatar: '',
        name: '',
        money: '',
        type: '',
        human: ''
      },
      time: '',
      chartLineData: {},
      chartMapData: {},
      condition: {
        name: '',
        phone: '',
        rechargeTime: '',
        foodListrechargeType: '',
        rechargeOpearator: '',
        gender: '',
        level: '',
        data: ''
      },
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1
      },
      rechargePagination: {
        currentPage: 1,
        pageTotal: -1
      },
      tableData: []
    }
  },
  filters: {
    formatRecharge(value) {
      const type = ['自动充值', '人工充值']
      return type[value - 1]
    }
  },
  created() {
    this._getVipRechargeList({ curpage: 1 })
    this._getVipAreaData({
      search_mode: 'recharge',
      curpage: 1,
      see_type: 'province'
    })
    this.changeRechargeChartData({
      search_mode: 'seven_day',
      entry_mode: 'rechange'
    })
  },
  methods: {
    /**
     * 获取会员充值列表
     * @param params
     */
    _getVipRechargeList(params) {
      this.api.getVipRechargeList(params).then(res => {
        this.utils.setCommonCode(res, this)
        this.rechargeAmount = res.recharge_amount
      })
    },
    /**
     * 切换充值数据
     * @param params
     * @param index
     */
    changeRechargeChartData(params, index) {
      if (index >= 0) {
        this.activeIndex = index
      }
      params.entry_mode = 'rechange'
      this.api.changeData(params).then(res => {
        if (res.recharge_data.length > 0) {
          if (params.search_mode === 'real_time') {
            this.time = new Date().toLocaleDateString().replace(/\//g, '-')
          } else {
            this.time = `${res.recharge_data[0].date_time}~${
              res.recharge_data.slice(-1)[0].date_time
            }`
          }
        }
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartLineData = res.rechargeData
      })
    },
    /**
     * 充值
     */
    vipRechargeAmount() {
      const { id } = this.personalInfo
      const { money, type, human } = this.form
      const data = {
        member_id: id,
        prepaid_money: money,
        recharge_type: type,
        operator: human
      }
      this.api.recharge(data).then(res => {
        this.$notify({
          type: 'success',
          message: '充值成功~！🙂'
        })
        this.dialogRechargeVisible = false
        // 刷新列表
        this._getVipRechargeList({
          curpage: this.pagination.currentPage
        })
      })
    },
    /**
     * 打开充值弹窗
     * @param row
     */
    openRechargePop(row) {
      this.personalInfo = row
      this.form.name = row.name
      this.form.avatar = row.avatar
      this.dialogRechargeVisible = true
    },
    /**
     * 获取会员充值分布数据
     * @param params
     */
    _getVipAreaData(params) {
      this.api.getVipAreaData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartMapData = res.areaData
        this.rechargePagination.pageTotal = +res.page_count
      })
    }
  }
}
</script>
